export default __webpack_public_path__ + "static/media/llbean.9517eb7c.svg";